<template>
  <div class="bin-barcode">
    <div class="bin-barcode__info">
      <div class="bin-barcode__location_code">Location code</div>
    </div>
    <div class="bin-barcode_img">
      <img src="@/assets/images/barcode_ex.png" width="200" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelPDF'
}
</script>

<style scoped lang="scss">
.bin-barcode {
  width: 300px;
  height: 200px;
  padding: 10px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .bin-barcode__info {
    text-transform: uppercase;
    letter-spacing: 1px;
    text-align: center;
    color: #000000;
    margin-bottom: 20px;
    .bin-barcode__location_code {
      font-size: 18px;
      font-weight: 700;
    }
  }
  .bin-barcode_img {
    max-width: 280px;
    max-height: 150px;
    margin: 0 auto;
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
}
</style>
